<template>
  <teleport to="body">
    <div class="fixed bottom-4 right-4 z-50 space-y-2 w-80">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="flex items-start gap-2 rounded-lg border px-3 py-2 text-sm bg-white"
        :class="toast.kind === 'error' ? 'border-red-200' : 'border-emerald-200'"
      >
        <span
          class="mt-1.5 h-2 w-2 rounded-full shrink-0"
          :class="toast.kind === 'error' ? 'bg-red-500' : 'bg-emerald-500'"
        ></span>
        <span class="text-gray-800 break-words min-w-0">{{ toast.message }}</span>
        <button class="ml-auto text-gray-400 hover:text-gray-600" @click="dismiss(toast.id)">×</button>
      </div>
    </div>
  </teleport>
</template>

<script>
// The one notification pattern for the /data ecosystem. Parents call
// this.$refs.toast.push('Saved', 'success') — errors persist until dismissed,
// successes auto-dismiss.
let nextId = 1;

export default {
  name: 'EtlToast',
  data() {
    return { toasts: [], timers: {} };
  },
  beforeUnmount() {
    Object.values(this.timers).forEach(clearTimeout);
  },
  methods: {
    push(message, kind = 'success') {
      const id = nextId++;
      this.toasts.push({ id, message, kind });
      if (kind !== 'error') {
        this.timers[id] = setTimeout(() => this.dismiss(id), 4000);
      }
    },
    dismiss(id) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
      if (this.timers[id]) {
        clearTimeout(this.timers[id]);
        delete this.timers[id];
      }
    },
  },
};
</script>
